import { React, useEffect, useState } from "react";
import Profile_header from "./header";
import TabNavItem from "./navtabs";
import TabContent from "./contenttabs";
import Order_profile from "./contenttabs/order";
import Edit_profile from "./contenttabs/edit-account";
import Edit_Address from "../component-address";
import Password_profile from "./contenttabs/edit-password";
import { useUserStore } from "../../store/useUserStore";
import { useNavigate } from "react-router-dom";
import Avatar_user from "./component-avatar";

function Profile_content() {
  const { removeUser, user } = useUserStore((state) => state);
  const navigate = useNavigate();
  const [popupAvatar, setpopupAvatar] = useState(false);
  const [popupAvatarModal, setpopupAvatarModal] = useState(false);

  const HandleLogout = () => {
    removeUser();
    navigate("/");
  };

  const HandleAvatar = () => {
    setpopupAvatar(true);
    setpopupAvatarModal(true);
  };

  const HandleModalAvatar = () => {
    if (popupAvatar) {
      setpopupAvatar(false);
    } else {
      setpopupAvatar(true);
    }
    if (popupAvatarModal) {
      setpopupAvatarModal(false);
    } else {
      setpopupAvatarModal(true);
    }
  };

  const [activeTab, setActiveTab] = useState("1");
  return (
    <div id="profile">
      <Profile_header />
      <div className="pcontent">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="tabs ">
                <div className="profileNav">
                  <div className="userInfo">
                    <a href="#!" onClick={HandleAvatar}>
                      <img
                        src={user?.avatar}
                        className="img-fluid"
                        alt=""
                        title=""
                        width="100"
                        height="100"
                      />
                    </a>
                    <h2 className="userName">{user.name}</h2>
                    <p className="userPhone">{user.mobile}</p>
                  </div>
                  <ul>
                    <TabNavItem
                      title="ویرایش اطلاعات من"
                      id="1"
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                    />

                    <TabNavItem
                      title="آدرس های من"
                      id="2"
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                    />

                    <TabNavItem
                      title="سفارش های من"
                      id="3"
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                    />

                    <li title="خروج" id="4" onClick={HandleLogout}>
                      خروج
                    </li>
                  </ul>
                </div>
                <div className="profileTab">
                  {/* Order tab */}
                  <TabContent id="3" activeTab={activeTab}>
                    <Order_profile />
                  </TabContent>
                  <TabContent id="2" activeTab={activeTab}>
                    <Edit_Address />
                  </TabContent>
                  {/* Edit account tab*/}
                  <TabContent id="1" activeTab={activeTab}>
                    <Edit_profile />
                  </TabContent>
                  {/* Edit Password tab*/}
                  {/* <TabContent id="3" activeTab={activeTab}>
                                        <Password_profile />
                                    </TabContent> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          popupAvatarModal ? "modal_bg_avatar active" : "modal_bg_avatar"
        }
        onClick={HandleModalAvatar}
      ></div>
      <Avatar_user showPopup={popupAvatar} />
    </div>
  );
}

export default Profile_content;
